import React from "react";
import { Facebook, Instagram, Phone, MapPin } from "lucide-react";
import { restaurant } from "../mock";
import { useLang } from "../i18n/LanguageContext";

function TikTokIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.3 3h-3.02v11.9a2.4 2.4 0 1 1-2.4-2.4c.16 0 .32.02.48.05V9.5a5.5 5.5 0 0 0-.48-.02 5.42 5.42 0 1 0 5.42 5.42V8.9a7.28 7.28 0 0 0 4.24 1.36V7.24a4.28 4.28 0 0 1-2.94-1.42Z" />
    </svg>
  );
}

export default function Footer() {
  const { t } = useLang();
  const navItems = [
    { l: t("nav.about"), h: "#chisiamo" },
    { l: t("nav.services"), h: "#servizi" },
    { l: t("nav.menu"), h: "#menu" },
    { l: t("nav.reservation"), h: "#prenota" },
    { l: t("nav.gallery"), h: "#galleria" },
    { l: t("nav.contact"), h: "#contatti" },
  ];

  return (
    <footer className="bg-[#141110] text-white/70 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          <div>
            <p className="font-display text-2xl text-white mb-1">L'angolo <span className="italic text-[#C9A24B]">del Gusto</span></p>
            <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-5">{t("footer.tagline")}</p>
            <p className="text-sm leading-relaxed max-w-xs">{t("footer.desc")}</p>
            <div className="flex gap-3 mt-6">
              <Social href={restaurant.socials.facebook}><Facebook size={18} /></Social>
              <Social href={restaurant.socials.instagram}><Instagram size={18} /></Social>
              <Social href={restaurant.socials.tiktok}><TikTokIcon size={18} /></Social>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-5">{t("footer.nav")}</h4>
            <ul className="space-y-3 text-sm">
              {navItems.map((i) => (
                <li key={i.h}><a href={i.h} className="hover:text-[#C9A24B] transition-colors">{i.l}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-5">{t("footer.where")}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={17} className="text-[#C9A24B] mt-0.5 flex-shrink-0" />
                <span>{restaurant.address}, {restaurant.city}</span>
              </li>
              <li>
                <a href={restaurant.phoneHref} className="flex items-center gap-3 hover:text-[#C9A24B] transition-colors">
                  <Phone size={17} className="text-[#C9A24B]" />{restaurant.phone}
                </a>
              </li>
            </ul>
            <a href={restaurant.delivery} target="_blank" rel="noopener noreferrer"
              className="inline-block mt-6 border border-[#C9A24B] text-[#C9A24B] hover:bg-[#C9A24B] hover:text-[#1C1815] px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300">
              {t("footer.order")}
            </a>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} L'angolo del Gusto. {t("footer.rights")}</p>
          <p>{t("footer.made")}</p>
        </div>
      </div>
    </footer>
  );
}

function Social({ href, children }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer"
      className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:bg-[#C9A24B] hover:text-[#1C1815] hover:border-[#C9A24B] transition-all duration-300">
      {children}
    </a>
  );
}